(function (w, d) {
  'use strict';
  if (w.__rlcMetaHandoffV1 || (w.Shopify && w.Shopify.designMode)) return;
  w.__rlcMetaHandoffV1 = true;
  var KEY = 'rlc_meta_handoff_v1';
  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_content', 'utm_term', 'utm_source_platform', 'utm_creative_format', 'utm_marketing_tactic'];
  var META = ['fbclid', 'meta_campaign_id', 'meta_adset_id', 'meta_ad_id', 'meta_placement', 'campaign_id', 'adset_id', 'ad_id', 'placement', 'site_source_name'];
  var GOOGLE = ['gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid', 'srsltid', 'msclkid'];
  var KEYS = UTM.concat(META, GOOGLE, ['rlc_product']);
  var params = new URLSearchParams(w.location.search);
  function clean(v) { return String(v || '').replace(/[\u0000-\u001F\u007F]/g, '').slice(0, 500); }
  function readCookie(name) {
    var match = d.cookie.match('(?:^|; )' + name + '=([^;]*)');
    try { return match ? clean(decodeURIComponent(match[1])) : ''; } catch (e) { return ''; }
  }
  function validMetaCookie(v) { return /^fb\.\d+\.\d+\.[A-Za-z0-9._-]+$/.test(v) ? v : ''; }
  function currentFbc(values, savedAt) {
    var click = clean(values.fbclid).slice(0, 220);
    var saved = validMetaCookie(clean(values.fbc));
    var cookie = validMetaCookie(readCookie('_fbc'));
    if (click) {
      if (saved && saved.split('.').slice(3).join('.') === click) return saved;
      if (cookie && cookie.split('.').slice(3).join('.') === click) return cookie;
      return 'fb.1.' + savedAt + '.' + click;
    }
    return saved || cookie;
  }
  function isMeta() {
    var source = (params.get('utm_source') || '').toLowerCase();
    return /^(an|fb|facebook|facebook_ads|ig|instagram|meta|msg|messenger|th|threads)$/.test(source) ||
      (params.get('utm_source_platform') || '').toLowerCase() === 'meta' ||
      ((params.get('utm_medium') || '').toLowerCase() === 'paid_social' && /meta|facebook|instagram/.test(source)) ||
      META.some(function (k) { return !!params.get(k); });
  }
  function readSaved() {
    try {
      var record = JSON.parse(w.sessionStorage.getItem(KEY) || 'null');
      return record && record.values && Date.now() - record.saved_at < 86400000 ? record : null;
    } catch (e) { return null; }
  }
  var record;
  if (isMeta()) {
    // Replace a paid touch atomically so a new ad cannot inherit the previous ad's IDs.
    var landing = params.get('rlc_landing_page');
    record = {saved_at: Date.now(), values: {}, landing_page: (landing === '/pages/red-light-therapy-for-joint-pain-guide' || landing === '/pages/neuropathy-relief' || landing === '/pages/red-light-therapy-for-pain-relief-guide') ? landing : w.location.pathname};
    KEYS.forEach(function (k) { if (params.get(k)) record.values[k] = clean(params.get(k)); });
    ['fbc', 'fbp'].forEach(function (k) {
      var v = validMetaCookie(clean(params.get(k))) || validMetaCookie(readCookie('_' + k));
      if (v) record.values[k] = v;
    });
    var fbc = currentFbc(record.values, record.saved_at);
    if (fbc) record.values.fbc = fbc;
    try { w.sessionStorage.setItem(KEY, JSON.stringify(record)); } catch (e) {}
  } else {
    // A fresh Google-only visit must never be relabeled using retained Meta state.
    if (GOOGLE.some(function (k) { return !!params.get(k); })) {
      try { w.sessionStorage.removeItem(KEY); } catch (e) {}
      return;
    }
    record = readSaved();
  }
  if (!record) return;
  function decorate(link) {
    try {
      var target = new URL(link.href, w.location.origin);
      if (target.protocol !== 'https:' || !/^(www\.)?luscentred\.com$/.test(target.hostname)) return;
      UTM.concat(META, ['fbc', 'fbp']).forEach(function (k) { target.searchParams.delete(k); });
      Object.keys(record.values).forEach(function (k) { target.searchParams.set(k, record.values[k]); });
      var fbc = currentFbc(record.values, record.saved_at);
      if (fbc) target.searchParams.set('fbc', fbc);
      var fbp = validMetaCookie(readCookie('_fbp')) || record.values.fbp;
      if (fbp) target.searchParams.set('fbp', fbp);
      target.searchParams.set('rlc_page', w.location.pathname);
      target.searchParams.set('rlc_landing_page', record.landing_page);
      if (record.values.rlc_product === 'blanket' && /\/products\/(red-infrared-light-therapy-led-mat|infrared-red-light-therapy-whole-body-mat-sleeping-bag)\/?$/.test(target.pathname)) {
        target.pathname = target.pathname.replace(/\/products\/.*$/, '/products/red-infrared-light-therapy-led-mat');
        target.searchParams.set('variant', '46025364406458');
      }
      link.href = target.toString();
    } catch (e) {}
  }
  function decorateAll() { d.querySelectorAll('a[href*="luscentred.com"]').forEach(decorate); }
  function init() {
    decorateAll();
    // This asset must follow legacy rlc-tracking.js; its Meta decoration then wins
    // over the legacy Google-only click handler while retaining both click IDs.
    d.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a[href*="luscentred.com"]') : null;
      if (link) decorate(link);
    }, true);
    w.setTimeout(decorateAll, 1600);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})(window, document);
